class TurnoverShopRestrictionStrategy

	constructor: (@StrategyFactory) ->
	apply: (query, shop) ->

		criteria = query
		.criteria 'shop_id', '=', shop

		return query
